import React from 'react';
import Index from './Index';
import GeneralLedgerView from '../components/views/GeneralLedgerView';
import { modules } from '../config/const';

function GeneralLedgerPage() {
  return <Index content={GeneralLedgerView} module={modules.GeneralLedger} />;
}

export default GeneralLedgerPage;
